module.exports = __webpack_public_path__ + "img/img-sol-img-06.6e3301e5.png";